export default __webpack_public_path__ + "static/media/liron_hadar.92e3a531.jpeg";